import { Request } from '../../../httpClient/serverApi/requests/Request';
import { ISingleIdParams } from '../../../spacesPlatform/utils/actionParams';
import { FlowLinkedTaskAllowedActions } from '../types/FlowLinkedTaskAllowedActions';

export class GetLinkedTaskActionsRequest extends Request<ISingleIdParams, FlowLinkedTaskAllowedActions> {
 constructor(id: string) {
   super('getLinkedTaskActions', { id: id });
 }
}
